import { useQuery } from '@tanstack/react-query';
import { accountApi } from '@/api/commercial/accounts';

export function useCanSearchGroupContacts(
  economicGroupId: string | undefined,
  currentAccountId: string | undefined,
  documentType: string | undefined,
) {
  const enabled = documentType === 'cnpj' && !!economicGroupId;
  const { data } = useQuery({
    queryKey: ['economic-group', economicGroupId, 'contact-search-accounts'],
    queryFn: () => accountApi.findMany({ economicGroupId, limit: 2 }),
    enabled,
  });

  // Two results suffice: at most one can be the current account.
  return (
    enabled &&
    !!data?.docs.some(
      (account) => account.economicGroupId === economicGroupId && account.id !== currentAccountId,
    )
  );
}
